export const exitFullscreen = () => {
  if (document.exitFullscreen) {
    document.exitFullscreen()
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen()
  } else if (document.msExitFullscreen) {
    document.msExiFullscreen()
  } else if (document.webkitCancelFullScreen) {
    document.webkitCancelFullScreen()
  }
}
export const openFullscreen = el => {
  const element = el || document.documentElement
  if (element.requestFullscreen) {
    element.requestFullscreen()
  } else if (element.webkitRequestFullScreen) {
    element.webkitRequestFullScreen()
  } else if (element.mozRequestFullScreen) {
    element.mozRequestFullScreen()
  } else if (element.msRequestFullscreen) {
    // IE11
    element.msRequestFullscreen()
  }
}
function fullscreenElement() {
  var fullscreenEle = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement
  return fullscreenEle
}
export const toggleFullscreen = () => {
  const isFullscreen = !!fullscreenElement()
  if (isFullscreen) {
    exitFullscreen()
  } else {
    openFullscreen()
  }
}
